export type Dictionary<T> = Record<string, T>;

/** @returns the non-prototype keys of the given object */
export const getKeys = (obj: object): string[] => {
    /* eslint-disable-line */
    return Object.getOwnPropertyNames(obj);
};

export const values = <T = any>(obj: { [key: string]: T }): T[] => {
    return getKeys(obj).map((key: string): T => obj[key]);
};

export const forEach = <T>(
    obj: Dictionary<T>,
    action: (key: string, value: T) => void,
): void => {
    getKeys(obj).forEach((key: string): void => action(key, obj[key]));
};

export const map = <T, R>(
    obj: Dictionary<T>,
    mapper: (key: string, value: T) => R,
): R[] => {
    return getKeys(obj).map((key: string): R => mapper(key, obj[key]));
};

type NonNullAssertion = <T>(val: T, msg?: string) => asserts val is NonNullable<T>;

export const assertNotNull: NonNullAssertion = <T>(
    val: T,
    msg?: string,
): asserts val is NonNullable<T> => {
    if (val == null) {
        throw new Error(msg);
    }
};

export const toDictionary = <T, V>(
    arr: T[],
    keyMapper: (input: T) => string,
    valueMapper: (input: T) => V,
): Dictionary<V> => {
    const result: Dictionary<V> = {};
    arr.forEach((entry) => {
        result[keyMapper(entry)] = valueMapper(entry);
    });
    return result;
};
